import React from 'react';
import SectionCard from './SectionCard';
import { Box, Button } from "@mui/material";

const Construction = ({ projectId }) => {

    const handleScheduleClick = () => {
        const url = `/projects/${projectId}/dashboard/schedule`;
        window.open(url, "_blank");
    };

    const handleCostClick = () => {
        const url = `/projects/${projectId}/dashboard/cost-management`;
        window.open(url, "_blank");
    };


    return (
        <>
            <SectionCard title="Construction/Development" description="Check the status of Construction/Development by clicking on the Schedule or Cost Dashboard buttons.">
                <Box display="flex" gap={1}>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleScheduleClick}
                        sx={{
                            background: "#e0f7ff",
                            color: "#5995d5",
                            fontSize: "12px",
                            lineHeight: "100%",
                            minWidth: "230px",
                            padding: "10px 20px",
                            fontWeight: 800,
                            textTransform: "none",
                            boxShadow: "none",
                        }}
                    >
                        Schedule Dashboard
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleCostClick}
                        sx={{
                            background: "#e0f7ff",
                            color: "#5995d5",
                            fontSize: "12px",
                            lineHeight: "100%",
                            minWidth: "230px",
                            padding: "10px 20px",
                            fontWeight: 800,
                            textTransform: "none",
                            boxShadow: "none",
                        }}
                    >
                        Cost Dashboard
                    </Button>
                </Box>
            </SectionCard>


        </>
    );
}

export default Construction;
